import {Injectable} from '@angular/core';
import {PortalAuthService} from '@portal-commons/portal-auth.service';
import {UserInfo} from '@portal/models/user-info';
import {Observable, of} from 'rxjs';
import {map, switchMap, take} from 'rxjs/operators';
import zd from '../../portal-components/online-deal/zd-onlinedeal/zd-onlinedeal.json';

@Injectable({
  providedIn: 'root',
})
export class UserInfoService {
  userInfo$: Observable<UserInfo | null>;

  constructor(private portalAuthService: PortalAuthService) {
    this.userInfo$ = this.portalAuthService.userInfo$.pipe(
      take(1),
      switchMap(userInfo => {
        if (userInfo === undefined) {
          return this.portalAuthService.getUserInfo();
        }
        return of(userInfo);
      }),
    );
  }

  isOnlineDeal(): Observable<boolean> {
    return this.userInfo$.pipe(map(userInfo => !!userInfo?.onlinedeal));
  }

  isNewOnlineDealCustomer(): Observable<boolean> {
    return this.userInfo$.pipe(map(userInfo => userInfo?.onlinedeal === zd.ZDOnlineLeasingType.Neukunde));
  }

  isExistingOnlineDealCustomer(): Observable<boolean> {
    return this.userInfo$.pipe(map(userInfo => userInfo?.onlinedeal === zd.ZDOnlineLeasingType.Bestandskunde));
  }

  isUser(): Observable<boolean> {
    return this.userInfo$.pipe(map(userInfo => userInfo?.roles.includes('user') ?? false));
  }

  isAdmin(): Observable<boolean> {
    return this.userInfo$.pipe(map(userInfo => userInfo?.roles.includes('admin') ?? false));
  }
}
